<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_v"></a><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/04_Foreword">Foreword <em class="italic">by Geoff Walden</em></a></h2>
<h2 class="toc"><a href="#/xhtml/05_Cautionary">A Cautionary Note</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01">1. <em class="italic">Führerhauptquartiere Wolfsschanze</em></a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">2. Inside the Lair of the Wolf</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">3. <em class="italic">Oberkommando des Heeres Mauerwald</em></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">4. <em class="italic">Feldkommandostelle Hochwald</em></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">5. <em class="italic">Oberkommando der Luftwaffe, Robinson</em></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">6. Other Headquarters in East Prussia</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">7. <em class="italic">Führerhauptquartier Werwolf</em></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">8. <em class="italic">Valkyrie</em> – The 20 July 1944 Assassination Attempt on Hitler at the <em class="italic">Wolfsschanze</em></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">9. The End in the East</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Sources" title="Link target outside of Sample">Sources</span><a id="page_vi"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c74d696e